<template>
  <div class="description">
    <div 
      v-for="(item, index) in chartDataQty.cities" 
      :key="index"
    >

      <div
        @click.stop="showModal = true"
        v-if="item.key == 'other'"
        class="d-inline-flex align-items-center"
        style="cursor: pointer"
      >
        <v-avatar
          tile
          v-bind:style="{'background-color':chartDataQty.color[index % 11]}"
          size="20"
          class="mx-1"
        />
        {{item.value}}

        <v-dialog
          v-model="showModal"
          max-width="500"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Thông tin đơn hàng khác</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="showModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-simple-table>
                <thead>
                  <tr>
                    <th class="text-center" style="font-weight: 500">Tên địa phương</th>
                    <th class="text-center" style="font-weight: 500">Tỷ lệ</th>
                    <th class="text-center" style="font-weight: 500">Số đơn hàng</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in otherQuantities" :key="item.name">
                    <td class="text-center">{{ item.text }}</td>
                    <td class="text-center">{{ item.percentage }}</td>
                    <td class="text-center">{{ item.countItems}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
            
          </v-card>
        </v-dialog>
      </div>

      <div v-if="item.key != 'other'" class="d-inline-flex align-items-center">
        <v-avatar
          tile
          v-bind:style="{'background-color':chartDataQty.color[index % 11]}"
          size="20"
          class="mx-1"
        />
        {{item.value}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    otherQuantities: {
      type: Array,
      default: () => ([])
    },
    chartDataQty: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showModal: false
    }
  }
}
</script>